import usePrivateLink from "../../config/usePrivateLink";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ReportHeader = ({ data }) => {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();
  const location = useLocation();
const tabs = [
    {
      id: "overview",
      title: "Overview",
      icon: "ri-line-chart-line",
      path: "/reports",
    },

    {
      id: "crdrreport",
      title: "Credit/ Debit Report",
      icon: "ri-calendar-event-line",
      path: "/reports/credit/debit",
    },

    // {
    //   id: "feereport",
    //   title: "Fee Report",
    //   icon: "ri-currency-line",
    //   path: "/reports/fee/report",
    // },
    // {
    //   id: "feereport",
    //   title: "Fee Report",
    //   icon: "ri-currency-line",
    //   path: "/report/fee/transactions",
    // },

    {
      id: "expensereport",
      title: "Expense Report",
      icon: "ri-money-dollar-circle-line",
      path: "/reports/expense/report",
    },

    {
      id: "feeduesreport",
      title: "Fee Dues Report",
      icon: "ri-file-list-3-line",
      path: "/reports/fee/due",
    },

    {
      id: "staffreport",
      title: "Staff Report",
      icon: "ri-user-line",
      path: "/reports/staff/report",
    },
  ];


  const filteredTabs = tabs.filter((tab) => hasAccess(tab.path));

  return (
    <div className="">
      {/* ✅ Sidebar Menu */}
      <div className="list-group shadow-sm mb-3" style={{ minWidth: "260px" }}>
        <h5 className="text-primary text-center p-2">{data}</h5>
        {filteredTabs.length === 0 && (
          <div className="text-center text-danger">
            You don't have permission to access any tabs.
          </div>
        )}
        {filteredTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const permission = hasAccess(tab.path);

          return (
            <button
              key={tab.id}
              className={`list-group-item list-group-item-action d-flex align-items-center ${
                isActive ? "bg-label-primary" : ""
              } ${!permission ? "disabled-tab" : ""}`}
              onClick={() => permission && navigate(tab.path)}
              style={{
                cursor: permission ? "pointer" : "not-allowed",
                color: !permission ? "red" : "inherit",
                backgroundColor: !permission ? "#f8d7da" : "inherit",
              }}
              disabled={!permission}
            >
              <i className={`${tab.icon} me-2`} />
              {tab.title}
            </button>
          );
        })}
      </div>

      {/* ✅ Page Content */}
    </div>
  );
};

export default ReportHeader;
